import { Module } from 'vuex';
import { IStoreRootState } from '@/store/interface';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { namespace } from 'vuex-class';
import { ForexHistoryState } from '@/feature/TrHistory/store/interface';
import modules from '@/feature/TrHistory/store/modules';

export const FOREX_HISTORY_MODULE_NAME = `trHistory`;
export const ForexHistoryStore = namespace(`trHistory`);

export default <Module<ForexHistoryState, IStoreRootState>> {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
	modules
}
